"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _system = require("@ori-ui/mui-bundle/system");
var _xDataGridPro = require("@ori-ui/mui-bundle/x-data-grid-pro");
var _constants = require("../constants");
// taken from original mui styles
const SELECTED_OPACITY = 0.08;
const HOVER_OPACITY = 0.04;
const styleOverrides = {
  root: {
    border: 0,
    color: _constants.colors.text.primary,
    // Scrollbar
    '@media (hover: hover) and (pointer: fine)': {
      '&, & *': {
        msOverflowStyle: '-ms-autohiding-scrollbar',
        scrollbarWidth: 'thin',
        scrollbarColor: `${_constants.colors.oriGrey[300]} transparent`
      },
      // eslint-disable-next-line @typescript-eslint/naming-convention -- css selector
      '::-webkit-scrollbar, & *::-webkit-scrollbar': {
        width: 10,
        height: 10
      },
      // eslint-disable-next-line @typescript-eslint/naming-convention -- css selector
      '::-webkit-scrollbar-track, & *::-webkit-scrollbar-track': {
        background: 'transparent'
      },
      // eslint-disable-next-line @typescript-eslint/naming-convention -- css selector
      '::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
        background: _constants.colors.oriGrey[300],
        borderRadius: 6,
        border: '2px solid transparent',
        backgroundClip: 'content-box'
      }
    }
  },
  columnHeaders: {
    zIndex: 2,
    fontSize: '1.2rem',
    background: _constants.colors.oriGrey[50],
    borderBottom: `1px solid ${_constants.colors.oriGrey[300]}`,
    boxShadow: '0px 1px 3px 0px rgba(51,51,51,0.2)'
  },
  // pinnedColumnHeaders: {
  //   background: colors.oriGrey[50],
  //   [`&.${gridClasses['pinnedColumnHeaders--left']}`]: {
  //     borderRight: `1px solid ${colors.oriGrey[300]}`,
  //     boxShadow: '1px 0px 3px 0px rgba(51,51,51,0.2)',
  //   },
  //   [`&.${gridClasses['pinnedColumnHeaders--right']}`]: {
  //     borderLeft: `1px solid ${colors.oriGrey[300]}`,
  //     boxShadow: '-1px 0px 3px 0px rgba(51,51,51,0.2)',
  //   },
  // },
  // pinnedColumns: {
  //   [`&.${gridClasses['pinnedColumns--left']}`]: {
  //     borderRight: `1px solid ${colors.oriGrey[300]}`,
  //     boxShadow: '1px 0px 3px 0px rgba(51,51,51,0.2)',
  //   },
  //   [`&.${gridClasses['pinnedColumns--right']}`]: {
  //     borderLeft: `1px solid ${colors.oriGrey[300]}`,
  //     boxShadow: '-1px 0px 3px 0px rgba(51,51,51,0.2)',
  //   },
  // },
  row: {
    // stripe rows
    '&.odd': {
      backgroundColor: _constants.colors.oriGrey[50],
      [`&:hover, &.${_material.tableRowClasses.hover}`]: {
        backgroundColor: (0, _system.alpha)(_constants.colors.commonColors.black, HOVER_OPACITY),
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      [`&.${_material.tableRowClasses.selected}`]: {
        backgroundColor: (0, _system.alpha)(_constants.colors.primary.main, SELECTED_OPACITY),
        [`&:hover, &.${_material.tableRowClasses.hover}`]: {
          backgroundColor: (0, _system.alpha)(_constants.colors.primary.main, SELECTED_OPACITY + HOVER_OPACITY),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: (0, _system.alpha)(_constants.colors.primary.main, SELECTED_OPACITY)
          }
        }
      }
    }
  },
  cell: {
    // compare data
    '& .compareData': {
      flexGrow: 1
    },
    '& .compareData .secondary': {
      fontSize: '1.2rem',
      color: _constants.colors.oriGrey.A400
    },
    '& .compareData .negative': {
      color: _constants.colors.error.dark
    },
    '& .compareData .positive': {
      color: _constants.colors.success.dark
    },
    [`&.${_xDataGridPro.gridClasses['cell--textRight']} .compareData *`]: {
      justifyContent: 'flex-end',
      textAlign: 'end'
    },
    [`&.${_xDataGridPro.gridClasses['cell--textCenter']} .compareData *`]: {
      justifyContent: 'center',
      textAlign: 'center'
    }
  },
  footerContainer: {
    borderTop: `1px solid ${_constants.colors.oriGrey[300]}`,
    fontSize: '1.2rem',
    color: _constants.colors.oriGrey.A400,
    justifyContent: 'center'
  }
};
const defaultProps = {
  hideFooterSelectedRowCount: true
};
var _default = exports.default = {
  styleOverrides,
  defaultProps
};
//# sourceMappingURL=MuiDataGrid.js.map